// custom.js

// Cache global partagé entre toutes les instances
const PRODUCT_CACHE = {};

document.addEventListener('alpine:init', () => {
  Alpine.data('ProductGroup', (initial_handle) => ({
    p_handle: initial_handle,
    isLoading: false,
    
    init() {
      console.log('✓ ProductGroup initialisé avec:', this.p_handle);
      
      // Pré-cache le produit actuel s'il n'est pas déjà en cache
      if (!PRODUCT_CACHE[this.p_handle]) {
        const currentSection = document.querySelector('[data-section-type="product"]');
        if (currentSection) {
          PRODUCT_CACHE[this.p_handle] = currentSection.innerHTML;
          console.log('✓ Produit actuel mis en cache:', this.p_handle);
        }
      }
    },
    
    async SwitchProduct(handle) {
      console.log('🔄 Changement vers:', handle);
      
      // Empêche le changement si c'est déjà le produit actuel
      if (handle === this.p_handle) {
        console.log('⚠️ Produit déjà sélectionné');
        return;
      }
      
      // Active l'indicateur de chargement
      let loadingPromise = setTimeout(() => {
            this.isLoading = true;
        }, 50);
      
      
      try {
        let newSectionHTML;
        
        // Vérifie si le produit est déjà en cache
        if (PRODUCT_CACHE[handle]) {
          console.log('✅ Produit trouvé en cache:', handle);
          newSectionHTML = PRODUCT_CACHE[handle];
          
          // Simule un petit délai pour une meilleure UX (optionnel)
          await new Promise(resolve => setTimeout(resolve, 50));

        } else {
          console.log('🌐 Chargement du produit depuis le serveur:', handle);
          
          // Récupère la page HTML complète du produit
          const response = await fetch(`/products/${handle}`);
          
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          
          const html = await response.text();
          
          // Parse le HTML reçu
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newSection = doc.querySelector('[data-section-type="product"]');
          
          if (!newSection) {
            console.error('❌ Section produit non trouvée');
            this.isLoading = false;
            return;
          }
          
          // Stocke dans le cache GLOBAL
          newSectionHTML = newSection.innerHTML;
          PRODUCT_CACHE[handle] = newSectionHTML;
          console.log('✓ Produit mis en cache:', handle);
        }

        clearTimeout(loadingPromise);
        
        // Trouve la section produit actuelle sur la page
        const currentSection = document.querySelector('[data-section-type="product"]');
        
        if (currentSection) {
          // Remplace le contenu
          currentSection.innerHTML = newSectionHTML;
          
          // Met à jour le handle actuel
          this.p_handle = handle;
          
          console.log('✓ Produit affiché:', handle);
          
          // Met à jour l'URL du navigateur
          window.history.replaceState({}, '', `/products/${handle}`);
          
          // Scroll vers le haut de la section (optionnel)
          currentSection.scrollIntoView({ behavior: 'smooth', block: 'start' });

          document.dispatchEvent(new CustomEvent('products:switched'));

          console.log('LOAD SHOP THE LOOK', `/products/${handle}`);
          loadShopTheLookProducts(`/products/${handle}`);
          
        }
        
      } catch (error) {
        console.error('❌ Erreur lors du changement de produit:', error);
      } finally {
        // Désactive l'indicateur de chargement
        this.isLoading = false;
      }
    },
    
    // Méthode pour précharger un produit (optionnel)
    async preloadProduct(handle) {
      if (PRODUCT_CACHE[handle]) {
        console.log('⚠️ Produit déjà en cache:', handle);
        return;
      }
      
      console.log('📥 Préchargement du produit:', handle);
      
      try {
        const response = await fetch(`/products/${handle}`);
        if (!response.ok) return;
        
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newSection = doc.querySelector('[data-section-type="product"]');
        
        if (newSection) {
          PRODUCT_CACHE[handle] = newSection.innerHTML;
          console.log('✓ Produit préchargé:', handle);
          console.log('📦 Cache contient maintenant:', Object.keys(PRODUCT_CACHE));
        }
      } catch (error) {
        console.error('❌ Erreur lors du préchargement:', error);
      }
    }
  }));
});

// Collection page - swatch switching on product cards
document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('change', function (e) {
    const radio = e.target;
    const card = radio.closest('product-card');
    if (!radio.classList.contains('opt-btn') || !card) return;
    if (card.closest('[data-section-type="product"]')) return;

    const productUrl = radio.dataset.productUrl;
    const productTitle = radio.dataset.productTitle;
    let images = [];

    try {
      images = JSON.parse(radio.dataset.productImages || '[]');
    } catch (err) {
      console.error('Error parsing product images:', err);
      return;
    }

    if (!images.length) return;

    const figure = card.querySelector('.product-card__figure');
    if (!figure) return;

    // --- Handle carousel (multiple images) ---
    const carousel = figure.querySelector('.product-card-carousel');
    if (carousel) {
      // Destroy Flickity if active
      if (carousel.classList.contains('flickity-enabled')) {
        Flickity.data(carousel).destroy();
      }

      // Rebuild all cells
      carousel.innerHTML = images.map(img => `
        <div class="carousel-cell" data-url="${productUrl}">
          <a href="${productUrl}" class="product-card__media" draggable="false" data-instant>
            <img src="${img.url}" alt="${img.alt || ''}" loading="eager" draggable="false">
          </a>
        </div>
      `).join('');

      // Déclencher la réinit Flickity
      document.dispatchEvent(new CustomEvent('swatch:switched'));

    } else {
      // --- Single image case ---
      const img = figure.querySelector('.product-card__media img');
      if (img) {
        img.src = images[0].url;
        img.srcset = '';
      }
      const link = figure.querySelector('a.product-card__media');
      if (link) link.href = productUrl;
    }

    // --- Update title ---
    const titleEl = card.querySelector('.product-title');
    if (titleEl && productTitle) {
      titleEl.textContent = productTitle;
      if (titleEl.tagName === 'A') {
        titleEl.href = productUrl;
      }
    }

    // --- Update card handle ---
    card.setAttribute('handle', radio.value);

    // --- Update wishlist ---
    const wishlist = card.querySelector('.wishlist-engine');
    if (wishlist) {
      wishlist.setAttribute('data-product_id', radio.dataset.productId);
      wishlist.setAttribute('data-variant_id', radio.dataset.variantId);
    }

    // --- Update quick buy (single variant form) ---
    const quickBuyForm = card.querySelector('product-form input[name="id"]');
    if (quickBuyForm) {
      quickBuyForm.value = radio.dataset.variantId;
    }

    // --- Update quick buy modal (multi-variant) ---
    const quickBuyModal = card.querySelector('quick-buy-modal');
    if (quickBuyModal) {
      quickBuyModal.setAttribute('handle', radio.value + '?variant=' + radio.dataset.variantId);
    }

    // --- Update quick buy button aria-controls ---
    const quickBuyButton = card.querySelector('button[aria-controls]');
    if (quickBuyButton && quickBuyModal) {
      quickBuyButton.setAttribute('aria-controls', quickBuyModal.id);
    }
  });

  // Initialise l'état visuel des swatches déjà cochés au chargement de la page
  document.querySelectorAll('product-card .opt-btn:checked').forEach(radio => {
    if (radio.closest('[data-section-type="product"]')) return;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  });
});

// ✅ Réinitialisation automatique des widgets Trustpilot via MutationObserver
// Couvre tous les cas : switch produit PDP, refresh drawer panier, ajout/suppression d'items
(function () {
  const observer = new MutationObserver(function (mutations) {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;

        const widgets = node.classList?.contains('trustpilot-widget')
          ? [node]
          : [...node.querySelectorAll('.trustpilot-widget')];

        widgets.forEach(function (widget) {
          if (window.Trustpilot?.loadFromElement) {
            window.Trustpilot.loadFromElement(widget, true);
          }
        });
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();


class SubCollectionsNav extends HTMLElement {
  connectedCallback() {
    this.scroller = this.querySelector('.sub-collections-nav__scroll');
    this.nextBtn = this.querySelector('.sub-collections-nav__arrow--next');

    if (!this.scroller) return;

    this.update = this.update.bind(this);
    this.onArrowClick = this.onArrowClick.bind(this);

    this.scroller.addEventListener('scroll', this.update, { passive: true });
    window.addEventListener('resize', this.update);
    this.nextBtn?.addEventListener('click', this.onArrowClick);

    const parentHandle = this.dataset.parent;
    this.querySelectorAll('.sub-collections-nav__link').forEach(link => {
      link.addEventListener('click', () => {
        sessionStorage.setItem('subNavScrollY', window.scrollY);
        if (parentHandle) sessionStorage.setItem('subNavParent', parentHandle);
      });
    });
  }

  disconnectedCallback() {
    this.scroller?.removeEventListener('scroll', this.update);
    window.removeEventListener('resize', this.update);
  }

  show() {
    this.removeAttribute('hidden');
    if (!this.scroller) {
      this.scroller = this.querySelector('.sub-collections-nav__scroll');
      this.nextBtn = this.querySelector('.sub-collections-nav__arrow--next');
      this.nextBtn?.addEventListener('click', this.onArrowClick);
      this.scroller?.addEventListener('scroll', this.update, { passive: true });
    }
    requestAnimationFrame(() => {
      this.scrollActiveIntoView();
      requestAnimationFrame(() => this.update());
    });
  }

  update() {
    const { scrollLeft, scrollWidth, clientWidth } = this.scroller;
    const maxScroll = scrollWidth - clientWidth;
    const hasOverflow = maxScroll > 2;
    const atEnd = scrollLeft >= maxScroll - 2;
    if (this.nextBtn) this.nextBtn.hidden = !hasOverflow || atEnd;
  }

  onArrowClick() {
    const amount = this.scroller.clientWidth * 0.7;
    this.scroller.scrollBy({ left: amount, behavior: 'smooth' });
  }

  scrollActiveIntoView() {
    const active = this.querySelector('.sub-collections-nav__link.is-active');
    if (!active) return;
    const links = Array.from(this.querySelectorAll('.sub-collections-nav__link'));
    const isLast = active === links[links.length - 1];
    if (isLast) {
      this.scroller.scrollLeft = this.scroller.scrollWidth;
    } else {
      const offset = active.offsetLeft - (this.scroller.clientWidth / 2) + (active.clientWidth / 2);
      this.scroller.scrollLeft = Math.max(0, offset);
    }
  }
}

function extractCollectionHandle(url) {
  if (!url) return null;
  try {
    const u = new URL(url);
    if (u.hostname !== window.location.hostname) return null;
    const match = u.pathname.match(/\/collections\/([^/?#]+)/);
    return match ? match[1] : null;
  } catch {
    return null;
  }
}

function initSubCollectionsNavs() {
  const navs = Array.from(document.querySelectorAll('sub-collections-nav'));
  if (navs.length === 0) return;

  if (navs.length === 1) {
    navs[0].show();
    return;
  }

  const savedParent = sessionStorage.getItem('subNavParent');
  const referrerHandle = extractCollectionHandle(document.referrer);
  const targetHandle = savedParent || referrerHandle;

  let targetNav = null;
  if (targetHandle) {
    targetNav = navs.find(n => n.dataset.parent === targetHandle);
  }
  if (!targetNav) {
    targetNav = navs.find(n => !n.hasAttribute('hidden')) || navs[0];
  }

  navs.forEach(n => { if (n !== targetNav) n.setAttribute('hidden', ''); });
  targetNav.show();
}

(function restoreSubNavScroll() {
  const savedScroll = sessionStorage.getItem('subNavScrollY');
  if (savedScroll === null) return;
  sessionStorage.removeItem('subNavScrollY');
  requestAnimationFrame(() => {
    window.scrollTo({ top: parseInt(savedScroll, 10), behavior: 'instant' });
  });
})();

customElements.define('sub-collections-nav', SubCollectionsNav);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSubCollectionsNavs);
} else {
  initSubCollectionsNavs();
}